import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
    selector: 'bell-icon-svg',
    templateUrl: './bell-icon-svg.component.html',
    styleUrls: ['./bell-icon-svg.component.scss'],
    imports: [CommonModule]
})
export class BellIconSvgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

